import {
  ArrowCircleUp,
  ChartLineUp,
  Gear,
  House,
  UserFocus,
} from "@phosphor-icons/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import detectLocation from "../../libs/detectLocation";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useCookies } from "react-cookie";
import axios from "axios";
import { toast } from "sonner";
import justConfirm from "../../libs/justConfirm";

const Navbar = () => {
  const pathActive = useLocation();
  const [namaGweh, setNamaGweh] = useState(null);
  const [cookies] = useCookies(["token"]);
  const navigate = useNavigate();

  // Menggunakan useEffect untuk navigasi
  useEffect(() => {
    if (!cookies.token) {
      navigate("/login");
    } else {
      try {
        const token = cookies.token;
        if (typeof token === "string" && token) {
          const userName = jwtDecode(token).email;
          setNamaGweh(userName);
          console.log("User logged in:", userName);
        } else {
          navigate("/login");
          throw new Error("Invalid token format");
        }
      } catch (error) {
        navigate("/login");
        console.error("Invalid token", error);
      }
    }
  }, [cookies.token, navigate]);

  const [data, setData] = useState([]);
  const [location, setLocation] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (namaGweh) {
      // Fetch data with async/await
      const fetchData = async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_SERVER}/api/attending/${namaGweh}`
          );
          if (!response.ok) throw new Error("Network response was not ok");
          const data = await response.json();
          setData(data);
        } catch (error) {
          setError(`An error occurred: ${error.message}`);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }

    // Get location
    const getLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            // Perbaikan destructuring coords
            const { latitude, longitude } = position.coords;

            // Panggil fungsi detectLocation untuk memeriksa lokasi
            const isInLocation = detectLocation(latitude, longitude);

            // Tentukan lokasi pengguna berdasarkan hasil detectLocation
            const locationRightNow = isInLocation
              ? "In Dhoho TV"
              : "Outside Dhoho TV";

            console.log(
              "🚀 ~ getLocation ~ locationRightNow:",
              locationRightNow
            );

            // Simpan lokasi ke state
            setLocation(locationRightNow);
          },
          (error) => {
            setError(error.message);
          }
        );
      } else {
        setError("Geolocation is not supported by this browser.");
      }
    };

    getLocation();
  }, [namaGweh]);

  if (loading) return <div></div>;
  if (error) return <></>;

  const isInLocation = location;
  const id_user = data.payload.datas.user.datas.id;
  
  const handleAttend = async (e) => {
    e.preventDefault();
    if (isInLocation === "")
      return toast.error("Please, use google chrome for attendancce");

    try {
      if (isInLocation === "Outside Dhoho TV") {
        const { confirm  } = justConfirm()
        const apakahMauIzin = await confirm();

        if (!apakahMauIzin) return;
      }
      if (data.payload.datas.absenceToday.isCheckIn === false) {
        await axios.post(
          `${process.env.REACT_APP_SERVER}/api/attendance/create`,
          {
            id_user,
            kehadiran: "H",
            position: isInLocation,
            is_acc: isInLocation === "Outside Dhoho TV" ? 0 : 1,
          }
        );
        if (isInLocation === "Outside Dhoho TV") {
          toast.success(
            "Check In Diproses, silahkan lanjutkan pekerjaan. Tunggu admin untuk mengecek data kamu!"
          );
        } else {
          toast.success("Check In is Success");
        }
        window.location.reload();

        return;
      } else if (
        data.payload.datas.absenceToday.isCheckIn === true &&
        data.payload.datas.absenceToday.isAcc === 0
      ) {
        toast.warning(
          "Permintaan kamu sudah di proses hari ini, silahkan tunggu admin"
        );
      } else if (
        data.payload.datas.absenceToday.isCheckIn === true &&
        data.payload.datas.absenceToday.isCheckOut === false
      ) {
        const idde = data.payload.datas.absenceToday.id_data;
        console.log("🚀 ~ handleAttend ~ idde:", idde);
        const response = await axios.put(
          `${process.env.REACT_APP_SERVER}/api/attendance/update`,
          {
            id: data.payload.datas.absenceToday.id_data,
          }
        );
        console.log("🚀 ~ handleAttend ~ response:", response);
        toast.success("Check Out is Success");
        window.location.reload();
        return;
      } else if (data.payload.datas.absenceToday.isCheckOut === true) {
        return toast.warning(
          "Hari ini kamu sudah absen dangan benar, silahkan absen besok lagi ya"
        );
      } else return toast.error("Program Kamu ada yang salah");
    } catch (e) {
      toast.error("buset ERROR gagal kirim data bang");
      setError("buset ERROR gagal kirim data bang");
    }
  };

  return (
    <nav
      className={
        pathActive.pathname === "/login" ||
        pathActive.pathname === "/register" ||
        pathActive.pathname === "/edit-profile"
          ? "hidden"
          : "fixed bottom-0 bg-slate-100 h-20 w-full shadow-inner flex items-center justify-evenly"
      }
    >
      <Link
        to="/"
        className="flex flex-col cursor-pointer gap-1 items-center justify-center"
      >
        <House
          size="26"
          weight={pathActive.pathname === "/" ? "fill" : "regular"}
          color={pathActive.pathname === "/" ? "black" : "gray"}
        />
        <p
          className={
            pathActive.pathname === "/"
              ? "text-xs text-black font-semibold"
              : "text-xs text-gray-500 font-semibold"
          }
        >
          Home
        </p>
      </Link>
      <Link
        to="/analytics"
        className="flex flex-col cursor-pointer gap-1 items-center justify-center"
      >
        <ChartLineUp
          size="26"
          weight={pathActive.pathname === "/analytics" ? "fill" : "regular"}
          color={pathActive.pathname === "/analytics" ? "black" : "gray"}
        />
        <p
          className={
            pathActive.pathname === "/analytics"
              ? "text-xs text-black font-semibold"
              : "text-xs text-gray-500 font-semibold"
          }
        >
          Analytics
        </p>
      </Link>
      <div onClick={handleAttend} className="list-none">
        <div className="relative -mt-4 shadow-inner bg-slate-100 rounded-full flex justify-center items-center">
          <div className="p-4">
            <div className="h-16 w-16 cursor-pointer bg-green-700 rounded-full shadow-lg flex justify-center items-center">
              <UserFocus size="26" weight="regular" color="white" />
            </div>
          </div>
        </div>
      </div>
      <Link
        to="/leave"
        className="flex flex-col cursor-pointer gap-1 items-center justify-center"
      >
        <ArrowCircleUp
          size="26"
          weight={pathActive.pathname === "/leave" ? "fill" : "regular"}
          color={pathActive.pathname === "/leave" ? "black" : "gray"}
        />
        <p
          className={
            pathActive.pathname === "/leave"
              ? "text-xs text-black font-semibold"
              : "text-xs text-gray-500 font-semibold"
          }
        >
          Leave
        </p>
      </Link>
      <Link
        to="/settings"
        className="flex flex-col cursor-pointer gap-1 items-center justify-center"
      >
        <Gear
          size="26"
          weight={pathActive.pathname === "/settings" ? "fill" : "regular"}
          color={pathActive.pathname === "/settings" ? "black" : "gray"}
        />
        <p
          className={
            pathActive.pathname === "/settings"
              ? "text-xs text-black font-semibold"
              : "text-xs text-gray-500 font-semibold"
          }
        >
          Settings
        </p>
      </Link>
    </nav>
  );
};

export default Navbar;
